import React from 'react';
import { ICollection, IContent } from 'types';
import { Swiper, SwiperSlide } from 'swiper/react';
import CollectionTitle from './CollectionTitle';

interface Props {
  collection: ICollection;
}

function CardCollection({ collection }: Props) {
  return (
    <div css={{ paddingLeft: '16px' }}>
      <CollectionTitle title={collection.title} />
      <Swiper loop spaceBetween={0} modules={[]}>
        {collection.contents?.map((c) => {
          const { id } = c as IContent;
          return (
            <SwiperSlide key={id}>
              <CardItem content={c as IContent} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

function CardItem({ content }: { content: IContent }) {
  return (
    <div
      css={{
        width: '240px',
        border: '1px solid #ddd',
        borderRadius: '8px',
      }}
    >
      <div
        css={{
          background: 'rgba(0, 0, 0, 0.03)',
          height: '140px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #ddd',
        }}
      >
        <img src={content.thumbnailUrl} css={{ maxHeight: '35px' }} />
      </div>
      <div css={{ padding: '16px' }}>
        <p
          css={{
            color: 'rgba(72, 73, 79, 1)',
            fontSize: '16px',
            fontWeight: 'bold',
            lineHeight: '21px',
          }}
        >
          {content.title}
        </p>
        <p
          css={{
            fontSize: '15px',
            fontWeight: '600',
            marginTop: '4px',
            lineHeight: '21px',
            color: 'rgba(138, 138, 138, 1)',
          }}
        >
          {content.subTitle}
        </p>
        <p
          css={{
            fontSize: '14px',
            lineHeight: '21px',
            color: 'rgba(72, 73, 79, 1)',
          }}
        >
          {content.description}
        </p>
      </div>
    </div>
  );
}

export default CardCollection;
